const BOT_TELEGRAM_PROD_URL = process.env.VUE_APP_BOT_TELEGRAM_PROD_URL || 'https://t.me/SchererAutoBot'
const BOT_TELEGRAM_BETA_URL = process.env.VUE_APP_BOT_TELEGRAM_BETA_URL || 'https://t.me/RasaSRSsellerBot'

const BOT_WHATSAPP_PROD_URL = process.env.VUE_APP_BOT_WHATSAPP_PROD_URL || '+55 49 9181-0141'
const BOT_WHATSAPP_BETA_URL = process.env.VUE_APP_BOT_WHATSAPP_BETA_URL || '+1 (555) 070-7699'

// Seleciona "production" vs "development" baseado no hostname, como feito em `src/config/logger.js`.
let cachedBotEnv = null
function resolveBotEnvByHostname () {
  if (cachedBotEnv) return cachedBotEnv

  let env = process.env.NODE_ENV === 'production' ? 'production' : 'development'
  if (typeof window === 'undefined') return env

  const hostname = window.location.hostname || ''

  const hostnameToEnv = {
    'devscherer.srssistemas.com': 'development',
    'scherer-sa.com.br': 'production',
  }

  for (const [domain, mappedEnv] of Object.entries(hostnameToEnv)) {
    if (hostname.includes(domain)) return mappedEnv
  }

  cachedBotEnv = env
  return cachedBotEnv
}

function envValue (valueForProd, valueForDevelopment) {
  const env = resolveBotEnvByHostname()
  return env === 'production' ? valueForProd : valueForDevelopment
}

export function getTelegramBotUrl () {
  return envValue(BOT_TELEGRAM_PROD_URL, BOT_TELEGRAM_BETA_URL)
}

export function getWhatsAppBotNumber () {
  return envValue(BOT_WHATSAPP_PROD_URL, BOT_WHATSAPP_BETA_URL)
}

function toWaMeUrl (phoneNumber) {
  const digits = String(phoneNumber || '').replace(/\D/g, '')
  if (!digits) return ''
  return `https://wa.me/${digits}`
}

// Retorna a URL pronta para abrir no navegador.
export function getWhatsAppBotUrl () {
  return toWaMeUrl(getWhatsAppBotNumber())
}

export function getBotsUrls () {
  return {
    telegram: {
      url: getTelegramBotUrl(),
    },
    whatsapp: {
      url: getWhatsAppBotUrl(),
    },
  }
}
